module.exports = function(ratings) {
	'use strict'
	ratings.directive('allRatingsDir',allRatingsDir);
	allRatingsDir.$inject=[];
	function allRatingsDir() {
		return {
			template: require('./partial/allratings.html'),
			controller:'allratingsController',
			controllerAs:'vmratings',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/ratingModule/allratings/js/directive/allratingsDirective.js
// module id = 575
// module chunks = 0